<template>
  <div class="item-container" v-if="goodsinfo">
    <div class="hd">
      <a-avatar
        shape="square"
        :size="64"
        icon="picture"
        :src="goodsinfo.image_url | goodsImg"
      />
    </div>
    <div class="bd">
      <div class="title" v-line-clamp="1">{{goodsinfo.title}}</div>
      <div class="desc">
        <span>电商平台：{{goodsinfo.item_type | goodsPlatform}}</span>
        <a-divider type="vertical"/>
        <span>商品ID：{{goodsinfo.item_id}}</span>
      </div>
      <div class="price">
        <span>价格：{{goodsinfo.price}}元</span>
        <a-divider type="vertical"/>
        <span>实付：{{goodsinfo.real_price}}元</span>
      </div>
    </div>
    <div class="fd">
      <slot name="fd"></slot>
    </div>
    <div class="operation">
      <div class="item">
        <a-icon type="delete"/>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    goodsinfo: {
      type: Object,
      required: false
    }
  },
  data() {
    return {}
  },
  filters: {
    goodsImg(str) {
      const arr = str.split(',')
      return arr[0]
    },
    goodsPlatform(str) {
      if (str == 1) {
        return '淘宝'
      } else if (str == 2) {
        return '京东'
      } else if (str == 3) {
        return '拼多多'
      }
    }
  },
  created() {
  },
  methods: {}
}
</script>
<style lang="less" scoped>
.item-container {
  width: 100%;
  border: 1px #cccccc solid;
  border-radius: 5px;
  display: flex;
  padding: 10px;
  flex-direction: row;
  position: relative;
  cursor: pointer;
  .bd {
    flex: 1;
    padding: 0 10px;
    .desc {
      color: #8a8a8a;
    }
    .price {
      color: #fa8c16;
    }
  }
  .operation {
    position: absolute;
    right: -20px;
    width: 20px;
    top: 0;
    bottom: 0;
    display: none;
    flex-direction: column;
    .item {
      height: 20px;
      width: 20px;
      line-height: 20px;
      text-align: center;
    }
  }
}
</style>